import {createUrl, getObjects} from "./api_common";

export const ENDPOINT_CATEGORIES = '/api/categories'

export function getCategories(parameters = {}) {
    const defaultParameters = {}
    let url = process.env.REACT_APP_API_URL + ENDPOINT_CATEGORIES
    url = createUrl(url, parameters, defaultParameters)
    return getObjects(url)
}